import { SelectionModel } from '@angular/cdk/collections';
import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar} from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { NavigationStart, Router } from '@angular/router';
import { filter, first, merge, Subscription,take } from 'rxjs';
import { ClinicListItem } from 'src/app/common/models/users-data/clinic-list-item.model';
import { ClinicService } from 'src/app/services/clinic.service';
import { UserManageService } from 'src/app/services/user-manage.service';
import { SelectClinicsSortingHeadersEnum } from './enums/select-clinics-sorting-headers-enum';
import { SelectClinicsDialogDataSource } from './select-clinics-dialog-datasource';
import { SortingDirectionsEnum } from 'src/common-panel/enums/sorting-directions-enum';

@Component({
    selector: 'app-select-clinics-dialog',
    templateUrl: './select-clinics-dialog.component.html',
    styleUrls: ['./select-clinics-dialog.component.css'],
    standalone: false
})
export class SelectClinicsDialogComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit
{

  subscription: Subscription = new Subscription()
  dataSource: SelectClinicsDialogDataSource = new SelectClinicsDialogDataSource(this.clinicService);

  displayedColumns = ['checkbox', 'id', 'name', 'address']

  selection = new SelectionModel<ClinicListItem>(true, []);

  search: FormControl = new FormControl({ value: '', disabled: true })

  searchListSource: ClinicListItem[] = []
  searchWasEmpty = true

  @ViewChild('clinicsPaginator') paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild(MatTable) table?: MatTable<ClinicService>;

  constructor(private clinicService: ClinicService, private router: Router, private elementRef: ElementRef, private cref: ChangeDetectorRef,
    private userManageService: UserManageService, private dialogRef: MatDialogRef<any>,public snackBar: MatSnackBar) { }

  ngOnInit(): void
  {
    this.dataSource.loadClinics();

    let l_sub = this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() =>
    {
      this.subscription.unsubscribe();
      l_sub.unsubscribe();
      this.dataSource.disconnect();
      this.elementRef.nativeElement.remove();
    });

    this.dialogRef.beforeClosed().pipe(take(1)).subscribe(() =>
      {
        this.search.setValue('')
      })

    // search set up
    this.clinicService.loadedClinicListSubject.pipe(first(l_loaded => l_loaded == true)).subscribe(() =>
    {
      this.searchListSource = this.clinicService.clinicList

      let l_clinics: string[] = this.clinicService.clinicList.map(function (item)
      {
        return item.clinicId ? item.clinicId : ''
      })
      this.search.enable()
    })

    let l_sub1 = this.search.valueChanges.subscribe(l_change =>
    {
      if (!(this.searchWasEmpty && l_change == ''))
      {
        this.filterByClinic(l_change)

        if (l_change == '')
        {
          this.searchWasEmpty = true
        } else
        {
          this.searchWasEmpty = false
        }
      }
    })

    if (this.userManageService.newUserClinicList.length > 0)
    {
      this.clinicService.clinicList.filter(l_clinic => this.userManageService.newUserClinicList.includes(l_clinic.clinicId)).forEach(l_clinic =>
      {
        this.selection.select(l_clinic)
      })
    } else if (this.userManageService.currentUser && this.userManageService.currentUser.shopList.length > 0)
    {
      this.clinicService.clinicList.filter(l_clinic => this.userManageService.currentUser!.shopList.includes(l_clinic.clinicId)).forEach(l_clinic =>
      {
        this.selection.select(l_clinic)
      })
    }



    this.subscription.add(l_sub1)
  }

  ngOnDestroy(): void
  {
    this.subscription.unsubscribe();
  }

  ngAfterContentInit(): void
  {
    this.cref.detectChanges()
  }

  ngAfterViewInit()
  {
    let l_sub = this.sort!.sortChange.subscribe(() =>
    {
      this.paginator!.pageIndex = 0;
      this.dataSource.sortDirection = this.sort!.direction as SortingDirectionsEnum;
      this.dataSource.sortingHeader = this.sort!.active as SelectClinicsSortingHeadersEnum;
      this.dataSource.sortData()
    });

    let l_sub2 = merge(this.sort!.sortChange, this.paginator!.page).subscribe(() =>
    {
      this.loadClinicsPage();
    });

    this.subscription.add(l_sub);
    this.subscription.add(l_sub2);

    this.loadClinicsPage();
  }


  loadClinicsPage()
  {
    this.dataSource.pageSize = this.paginator!.pageSize;
    this.dataSource.pageIndex = this.paginator!.pageIndex;
    this.dataSource?.loadClinicsPage();
  }

  onSubmit()
  {
    this.userManageService.newUserClinicList = this.selection.selected.map(l_value => l_value.clinicId);
    this.userManageService.newUserClinicListUpdatedSubject.next(true);

    if (!this.userManageService.currentClinic || (!this.userManageService.newUserClinicList.includes(this.userManageService.currentClinic.clinicId)))
    {
      if (this.userManageService.newUserClinicList.length > 0)
      {
        this.userManageService.currentClinic = this.selection.selected[0]
        this.clinicService.defualtClinicToUpdateSubject.next(true)
      }
    }
    
    if (this.userManageService.newUserClinicList.length > 0) { this.dialogRef.close(`Excellent`); } else
    {
      this.snackBar.open('Select at least one clinic', 'X');
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected()
  {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.count;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle()
  {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  filterByClinic(clinic: string)
  {
    this.clinicService.filterTableByClinic.next(clinic)
  }

  setSearchOption()
  {
    this.filterByClinic('')
    this.search.setValue('')
  }

  isDisabledButton()
  {

    return this.selection.isEmpty()
  }
}
